
const restaurants = [
   {
        name:"Domino's pizza",
        image:"https://i.imgur.com/RFT09c9.png",
        id:1,
        Products:[
            {
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 1
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 2
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 3
            }
        ]
   },
   {
        name:"Totos pizza gourmet",
        image:"https://i.imgur.com/gbH3qGr.png",
        id:2,
        Products:[
            {
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 4
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 5
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 6
            }
        ]
   },
   {
       name:"Pizza hub",
       image:"https://i.imgur.com/3kwjNR5.png",
       id:3,
       Products:[
           {
               name:"Pizza Hawaiana",
               imageUrl:"https://i.imgur.com/zBEebUv.png",
               description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
               price:"$27.900,00",
               id: 7
           },{
               name:"Pizza Hawaiana",
               imageUrl:"https://i.imgur.com/zBEebUv.png",
               description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
               price:"$27.900,00",
               id: 8
           },{
               name:"Pizza Hawaiana",
               imageUrl:"https://i.imgur.com/zBEebUv.png",
               description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
               price:"$27.900,00",
               id: 9
           }
       ]
   },
   {
        name:"Jenos pizza",
        image:"https://i.imgur.com/Ns1dUm1.png",
        id:4,
        Products:[
            {
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 10
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 11
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 12
            }
        ]
   },
   {
        name:"aurelio pizzeria",
        image:"https://i.imgur.com/klIGdcB.png",
        id:5,
        Products:[
            {
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 13
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 14
            },{
                name:"Pizza Hawaiana",
                imageUrl:"https://i.imgur.com/zBEebUv.png",
                description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
                price:"$27.900,00",
                id: 15
            }
        ]
   },
   {
       name:"The Crunch Pizza",
       image:"https://i.imgur.com/7Wchts9.png",
       id:6,
       Products:[
           {
               name:"Pizza Hawaiana",
               imageUrl:"https://i.imgur.com/zBEebUv.png",
               description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
               price:"$27.900,00",
               id: 16
           },{
               name:"Pizza Hawaiana",
               imageUrl:"https://i.imgur.com/zBEebUv.png",
               description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
               price:"$27.900,00",
               id: 17
           },{
               name:"Pizza Hawaiana",
               imageUrl:"https://i.imgur.com/zBEebUv.png",
               description:"Pizza Extra queso, jamón y piña. Tamaño y tipo de masa a elección.",
               price:"$27.900,00",
               id: 18
           }
       ]
   }
];

export {restaurants}
